import { SubAwardItem } from './AwardItem';
export const SubAwards = () => {
  return <div className="hidden items-start justify-center gap-xl tablet-sm:flex" data-sentry-component="SubAwards" data-sentry-source-file="SubAwards.tsx">
      <SubAwardItem title="혁신상 수상" description={<span>
            과학기술정보통신부 주최,
            <br />
            머니투데이/한국메타버스산업협회 주관
            <br />
            '2025 대한민국 가상융합대상' 혁신상 수상
          </span>} iconPath="/assets/award/award_sub_1.webp" data-sentry-element="SubAwardItem" data-sentry-source-file="SubAwards.tsx" />
      <SubAwardItem title="우수상 수상" description={<span>
            산업통상자원부 주최,
            <br />
            에듀테크산업협회 주관
            <br />
            '에듀테크 비즈니스 모델 공모전' 우수상
          </span>} iconPath="/assets/award/award_sub_2.webp" data-sentry-element="SubAwardItem" data-sentry-source-file="SubAwards.tsx" />
      <SubAwardItem title="소프트랩 실증" description={<span>
            한국교육학술정보원
            <br />
            2025 경기, 충북
            <br />
            에듀테크 소프트랩 실증
          </span>} iconPath="/assets/award/award_sub_3.webp" data-sentry-element="SubAwardItem" data-sentry-source-file="SubAwards.tsx" />
    </div>;
};